import './App.css';
import PersistentDrawerRight from './components/Drawer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/privacy-policy';

function App() {
  return (
    <Router>
      <PersistentDrawerRight />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
